import { render, staticRenderFns } from "./YourQuotesPage.vue?vue&type=template&id=7a4d60b0&scoped=true&"
import script from "./YourQuotesPage.vue?vue&type=script&lang=js&"
export * from "./YourQuotesPage.vue?vue&type=script&lang=js&"
import style0 from "./YourQuotesPage.vue?vue&type=style&index=0&id=7a4d60b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d60b0",
  null
  
)

export default component.exports